<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <!--<help :text="$t('help.events')" :title="$t('help.events_title')"/>-->

    <div class="position-relative">

      <loader v-if="loading"/>

      <v-server-table
        ref="appTable"
        name="triggersTable"
        url="/admin/triggers/handlers"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true"
        class="white-container">

        <template slot="beforeFilter">
          <b-row>
            <b-col>
              <router-link to="triggers/create">
                <b-button
                  class="px-4">
                  {{$t('triggers.add')}}
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </template>

        <template slot="id" slot-scope="props">
          <router-link :to="{path: `/triggers/edit/${props.row.id}`, params: props.row}" target="_blank">
            {{ props.row.id }}
          </router-link>
        </template>

        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{$t('global.showing')}}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
        </template>

        <template slot="active" slot-scope="props">
          <column-check :row="props.row" column="active"/>
        </template>

        <template slot="actions" slot-scope="props">
          <column-action
            :deleteUrl="`/triggers/handlers/${props.row.id}`"
            :route="{path: `/triggers/edit/${props.row.id}`, params: props.row}"
            @deleteItems="refreshTable('appTable')"
          />
        </template>

      </v-server-table>
    </div>
  </div>
</template>
<script>
  import axios from "@/utils/axios";
  import i18n from "@/utils/i18n";
  import {Event} from "vue-tables-2";

  export default {
    middleware: "auth",
    name: "Triggers",
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        params: {
          page: 1,
          filter: {}
        },
        columns: ["id", "trigger.title", "trigger.name", "active", "actions"],
        filters: [],
        options: {
          skin: [],
          headings: {
            id: "#",
            type: i18n.t('form.type'),
            "trigger.title": i18n.t('form.trigger_event'),
            "trigger.name": i18n.t('form.trigger_name'),
            active: i18n.t('form.active'),
            actions: i18n.t('button.edit')
          },
          sortable: [],
          filterByColumn: false,
          columnsDropdown: false,
          customFilters: ["custom"],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: {
                limit: data.limit,
                filter: data.custom,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch("error", e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.triggersTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    destroyed() {
      Event.$off('vue-tables.triggersTable.loaded');
    }
  }
</script>
